export var DateRangeFilterItems;
(function (DateRangeFilterItems) {
    DateRangeFilterItems["allTime"] = "all_time";
    DateRangeFilterItems["year"] = "year";
    DateRangeFilterItems["month"] = "month";
    DateRangeFilterItems["period"] = "dateRange";
    DateRangeFilterItems["day"] = "day";
    DateRangeFilterItems["week"] = "week";
})(DateRangeFilterItems || (DateRangeFilterItems = {}));
